import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import connectToRouter from 'js/lib/connectToRouter';

import { FootnoteProvider } from 'bundles/promo-template/components/FootnoteContext';
import { NativeDataProvider } from 'bundles/promo-template/components/NativeDataContext';
import { PromoTemplateProvider } from 'bundles/promo-template/contexts/PromoTemplateContext';
import { eventingTransform } from 'bundles/promo-template/utils/eventingTransform';

import 'css!../__styles__/index';

export type RouterProps = { pathname: string };

const PromoTemplateApp = ({ children }: React.PropsWithChildren<{}>) => (
  <PromoTemplateProvider>
    <FootnoteProvider>
      <NativeDataProvider>
        <div className="rc-PromoTemplateApp">{children}</div>
      </NativeDataProvider>
    </FootnoteProvider>
  </PromoTemplateProvider>
);

export default compose<{}, React.PropsWithChildren<{}>>(
  connectToRouter<RouterProps>((router) => {
    return {
      pathname: router.location.pathname,
    };
  }),
  Retracked.createTrackedContainer<RouterProps>(({ pathname }) => {
    const namespace = {
      app: 'promo_template',
      page: eventingTransform(pathname),
    };

    return {
      namespace,
    };
  })
)(PromoTemplateApp);
